import React from 'react';
import { View, Text } from 'react-native';
import { Icon } from 'react-native-elements';
import { MaterialIcons } from '@expo/vector-icons';
import CommerceItemProps from 'types/components/CommerceItemProps';
import UserRoleType from 'types/enums/UserRoleType';
import Measurements from 'types/models/Measurements';
import AppContext from 'contexts/AppContext';
import OrderContext from 'contexts/OrderContext';
import { styles } from 'styles/components/commerceItem';
import parseAmounts from 'utils/parseAmounts';
import CloverConnectionStatuses from './CloverConnectionStatuses';
import { useCloverPoints } from 'hooks/useCloverPointStatus';
import CloverConnectionStatusesTypes from 'types/models/CloverConnectionStatuses';

export default ({
  commerce,
  onPress,
  totalBilling,
  isMediumScreen,
  navigation,
  setShowMenuModalByCommerce,
  setTopPositionRelativeToContainer,
  containerRef,
}: CommerceItemProps): JSX.Element => {
  const { authData, hideCloverMonitoring } = React.useContext(AppContext);
  const { setCurrentCommerce, currentVenue } = React.useContext(OrderContext);
  const isCommerceEditor = authData?.user.role === UserRoleType.CommerceEditor;
  const commerceViewRef = React.useRef<View>(null);
  const [measure, setMeasure] = React.useState<Measurements | null>(null);
  const [getMeasurements, setGetMeasurements] = React.useState<boolean>(false);
  const [cloverPointStatuses, setCloverPointStatuses] = React.useState<CloverConnectionStatusesTypes>({
    online: 0,
    unstable: 0,
    offline: 0,
    whitoutPaper: 0,
    isInactive: 0,
  });

  const { cloverStatusesCount } = useCloverPoints({ currentVenue });

  React.useEffect(() => {
    setCloverPointStatuses(cloverStatusesCount(commerce));
  }, [commerce.cloverPoints]);

  React.useEffect(() => {
    if (isMediumScreen) return;
    if (getMeasurements) {
      if (measure) {
        if (setTopPositionRelativeToContainer) {
          setTopPositionRelativeToContainer(measure.top);
          setGetMeasurements(false);
        }
      }
      if (commerceViewRef.current && containerRef?.current) {
        commerceViewRef.current?.measureLayout(
          containerRef.current,
          (left, top, width, height) => {
            if (setTopPositionRelativeToContainer) {
              setTopPositionRelativeToContainer(top);
              setGetMeasurements(false);
            }
            setMeasure({ left, top, width, height });
            containerRef?.current.scrollTo({
              x: 0,
              y: top + 200,
              animate: true,
            });
          },
          () => {
            console.error('measurement failed');
          },
        );
      }
    }
  }, [getMeasurements]);

  return (
    <View style={{ paddingTop: 35 }} ref={commerceViewRef}>
      <View style={[styles.commerceItemContainer]}>
        <View
          style={[
            isMediumScreen ? styles.cardCommerceItemLarge : styles.cardCommerceItemSmall,
            isCommerceEditor && { justifyContent: 'center' },
          ]}
        >
          <View style={{ flex: 0.7 }}>
            <Text style={[styles.textCommerceName, isCommerceEditor && { textAlign: 'center' }]}>{commerce.name}</Text>
          </View>
          <View style={{ flex: 0.7 }}>
            <Text style={[styles.textCommerceAmountSold]}>{`${parseAmounts(totalBilling)}`}</Text>
          </View>
          {!hideCloverMonitoring && (
            <CloverConnectionStatuses
              cloverPointStatuses={cloverPointStatuses}
              navigation={navigation}
              commerceCode={commerce.code}
              venueCode={currentVenue?.code}
            />
          )}
          {isMediumScreen ? (
            <View style={{ flexDirection: 'row', flex: 0.25, marginRight: 50, justifyContent: 'space-between' }}>
              <MaterialIcons
                name="shopping-cart"
                type="ionicon"
                color={'#FFFFFF'}
                size={35}
                onPress={() => {
                  onPress();
                  navigation.navigate('OrdersScreen');
                }}
              />
              <Icon
                name="basket"
                type="ionicon"
                color={'#FFFFFF'}
                size={35}
                onPress={() => {
                  onPress();
                  navigation.navigate('BillingScreen');
                }}
              />
              <MaterialIcons
                name="ondemand-video"
                size={35}
                color={'#FFFFFF'}
                onPress={() => {
                  onPress();
                  navigation.navigate('VisualizationScreen');
                }}
              />
            </View>
          ) : (
            <Icon
              name="ellipsis-vertical"
              type="ionicon"
              color={'#FFFFFF'}
              size={25}
              onPress={() => {
                setShowMenuModalByCommerce(commerce.id);
                setCurrentCommerce(commerce);
                setGetMeasurements(true);
              }}
            />
          )}
        </View>
      </View>
    </View>
  );
};
